import { Builder } from '@builder.io/react'
import React from 'react'

import { HeadingClass, HeadingType } from 'enums'
import Bullet from '../../../images/BulletPoint.svg'
import CustomHeading, { headingTypePropObj, headingClassPropObj } from '../common/heading'

import './index.css'
import CdnImage from 'components/util/CdnImage'
// import CloudinaryImage from 'components/util/CloudinaryImage'
import CTAFive, { CTAFiveProps, CTAFiveRegisterProps } from '../cta/cta-five'

enum ImageSide {
  Left = 'left',
  Right = 'right'
}

enum Alignment {
  Center = 'center',
  Left = 'left',
  Right = 'right'
}

interface Props {
  backgroundImage: any
  imageSide: ImageSide
  // cloudinaryImage: any
  // cloudinaryMobileImage: any
  builderImage: any
  builderMobileImage: any
  imageAltText: string
  enableTopic: boolean
  topicText: string
  topicTextColor: string
  headingText: string
  headingTextColor: string
  contentText: string
  headingType: HeadingType
  headingClass: HeadingClass
  textAlignment: Alignment
  bulletPoint: any
  bulletAltText: string
  points: [{ text: string }]
  contextFooter: string
  CTAButton: CTAFiveProps
  showButton: boolean
}

const TextImage = ({
  backgroundImage = '',
  imageSide,
  // cloudinaryMobileImage,
  // cloudinaryImage,
  builderImage,
  builderMobileImage,
  imageAltText = '',
  enableTopic,
  topicText,
  topicTextColor,
  headingText,
  headingTextColor,
  contentText,
  headingType,
  headingClass,
  textAlignment,
  bulletPoint,
  bulletAltText = '',
  points,
  contextFooter,
  CTAButton,
  showButton
}: Props) => {
  const getTopic = () => {
    if (!enableTopic) return null
    return (
      <h3 className="font-semibold uppercase leading-6 tracking-wide text-indigo-600" style={{ color: topicTextColor }}>
        {topicText}
      </h3>
    )
  }

  const getAlignmentClass = () => {
    if (textAlignment === Alignment.Right) {
      return 'text-right'
    }
    if (textAlignment === Alignment.Center) {
      return 'text-center'
    }
    return 'text-left'
  }

  const signatureIndex = contextFooter?.lastIndexOf(',')
  const founder = signatureIndex > 0 && contextFooter.slice(0, signatureIndex + 1).trim()
  const oraganization = signatureIndex > 0 && contextFooter.slice(signatureIndex + 1, contextFooter.length).trim()

  const getContent = () => {
    if (imageSide === ImageSide.Left) {
      return (
        <>
          <div className="lg:absolute lg:inset-0">
            <div className="top-auto lg:absolute lg:inset-y-0 lg:left-0 lg:top-1/2 lg:h-full lg:w-1/2 lg:-translate-y-1/2">
              <CdnImage
                className="hidden h-full max-h-full object-contain lg:absolute lg:left-0 lg:block"
                url={builderImage}
                alt={imageAltText}
                steps={[705]}
                style={{
                  width: '705px',
                  height: '1275px',
                  maxHeight: '100%',
                  maxWidth: '100%'
                }}
              />
              {/* {builderImage ? (
                <CdnImage
                  className="hidden h-full max-h-full object-contain lg:absolute lg:left-0 lg:block"
                  url={builderImage}
                  alt={imageAltText}
                  steps={[705]}
                  style={{
                    width: '705px',
                    height: '1275px',
                    maxHeight: '100%',
                    maxWidth: '100%'
                  }}
                />
              ) : (
                <CloudinaryImage
                  className="hidden h-full max-h-full object-contain lg:absolute lg:left-0 lg:block"
                  publicId={cloudinaryImage?.public_id}
                  alt={imageAltText}
                  steps={[705]}
                  style={{
                    width: '705px',
                    height: '1275px',
                    maxHeight: '100%',
                    maxWidth: '100%'
                  }}
                />
              )} */}
              <CdnImage
                className="block object-contain lg:absolute lg:hidden"
                url={builderMobileImage}
                alt={imageAltText}
                steps={[480]}
                style={{
                  width: '100%',
                  height: '100%',
                  maxHeight: '18rem'
                }}
              />
              {/* {builderMobileImage ? (
                <CdnImage
                  className="block object-contain lg:absolute lg:hidden"
                  url={builderMobileImage}
                  alt={imageAltText}
                  steps={[480]}
                  style={{
                    width: '100%',
                    height: '100%',
                    maxHeight: '18rem'
                  }}
                />
              ) : (
                <CloudinaryImage
                  className="block object-contain lg:absolute lg:hidden"
                  publicId={cloudinaryMobileImage?.public_id}
                  alt={imageAltText}
                  steps={[480]}
                  style={{
                    width: '100%',
                    height: '100%',
                    maxHeight: '18rem'
                  }}
                />
              )} */}
            </div>
          </div>

          <div className="relative h-full w-full px-4 pt-4 pb-6 sm:px-6 sm:pt-16 md:pt-12 lg:mx-auto lg:grid lg:max-w-7xl lg:grid-cols-3 lg:px-8">
            <div className="col-span-2 lg:col-start-2 lg:pl-8">
              <div className="word-break-fix mx-auto max-w-prose text-base lg:ml-auto lg:mr-0">
                {getTopic()}
                <CustomHeading
                  //  text-4xl
                  classList="lg:mt-16 line-height-fix w-full h-full tracking-tight text-gray-900 text-left font-medium"
                  headingClass={headingClass}
                  headingType={headingType}
                  color={headingTextColor}
                >
                  {headingText}
                </CustomHeading>
                <div className="prose prose-indigo mt-5 text-gray-500">
                  <p
                    className={`enable-list-styles h-full w-full text-base ${getAlignmentClass()}`}
                    dangerouslySetInnerHTML={{ __html: contentText }}
                  ></p>
                </div>
                <div className="max-h-ful mt-4 mb-4 flex max-w-full flex-col gap-y-3">
                  {points?.map(point => (
                    <div className="flex items-center">
                      <img src={bulletPoint || Bullet} className="mr-2 h-8 w-8" alt={bulletAltText} />
                      <p className="font-normal text-black">{point.text}</p>
                    </div>
                  ))}
                </div>
                <div className="font-third ml-10 max-h-full max-w-full text-3xl text-black sm:text-5xl">
                  {signatureIndex > 0 ? (
                    <>
                      <p>{founder}</p>
                      <p>{oraganization}</p>
                    </>
                  ) : (
                    contextFooter
                  )}
                </div>
                {showButton && (
                  <div className="order-3 hidden lg:block">
                    <CTAFive {...CTAButton} backgroundColor="transparent" buttonAlignment="left" />
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      )
    }

    return (
      <>
        <div className="relative z-30 order-2 h-full w-full px-4 pt-4 pb-6 sm:px-6 sm:pt-16 md:pt-12 lg:order-1 lg:mx-auto lg:grid lg:max-w-7xl lg:grid-cols-3 lg:px-8">
          <div className="col-span-2 lg:col-start-1 lg:pl-8">
            <div className="word-break-fix mx-auto max-w-prose text-base lg:mr-auto lg:ml-0">
              {getTopic()}
              <CustomHeading
                classList="lg:mt-16 line-height-fix w-full h-full tracking-tight text-gray-900 text-left font-medium"
                headingClass={headingClass}
                headingType={headingType}
                color={headingTextColor}
              >
                {headingText}
              </CustomHeading>
              <div className="prose prose-indigo mt-5 text-gray-500">
                <p
                  className={`enable-list-styles text-base ${getAlignmentClass()}`}
                  dangerouslySetInnerHTML={{ __html: contentText }}
                ></p>
              </div>
              <div className="mt-4 mb-4 flex max-h-full max-w-full flex-col gap-y-3 md:gap-y-1">
                {points?.map(point => (
                  <div className="flex items-center">
                    <img src={bulletPoint || Bullet} className="mr-2 h-8 w-8" alt={bulletAltText} />
                    <p className="font-normal text-black">{point.text}</p>
                  </div>
                ))}
              </div>
              <div className="font-third ml-10 max-h-full max-w-full text-3xl text-black sm:text-5xl">
                {signatureIndex > 0 ? (
                  <>
                    <p>{founder}</p>
                    <p>{oraganization}</p>
                  </>
                ) : (
                  contextFooter
                )}
              </div>
              {showButton && (
                <div className="order-3 hidden lg:block">
                  <CTAFive {...CTAButton} backgroundColor="transparent" buttonAlignment="left" />
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="order-1 lg:absolute lg:inset-0 lg:order-2">
          <div className="top-auto lg:absolute lg:inset-y-0 lg:right-0 lg:top-1/2 lg:h-full lg:w-1/2 lg:-translate-y-1/2">
            <CdnImage
              className="right-0 hidden object-contain lg:absolute lg:block"
              url={builderImage}
              alt={imageAltText}
              steps={[705]}
              style={{
                width: '705px',
                height: '1275px',
                maxHeight: '100%',
                maxWidth: '100%'
              }}
            />
            {/* {builderImage ? (
              <CdnImage
                className="right-0 hidden object-contain lg:absolute lg:block"
                url={builderImage}
                alt={imageAltText}
                steps={[705]}
                style={{
                  width: '705px',
                  height: '1275px',
                  maxHeight: '100%',
                  maxWidth: '100%'
                }}
              />
            ) : (
              <CloudinaryImage
                className="right-0 hidden object-contain lg:absolute lg:block"
                publicId={cloudinaryImage?.public_id}
                alt={imageAltText}
                steps={[705]}
                style={{
                  width: '705px',
                  height: '1275px',
                  maxHeight: '100%',
                  maxWidth: '100%'
                }}
              />
            )} */}
            <CdnImage
              className="block object-contain lg:absolute lg:hidden"
              url={builderMobileImage}
              alt={imageAltText}
              steps={[480]}
              style={{
                width: '100%',
                height: '100%',
                maxHeight: '18rem'
              }}
            />
            {/* {builderMobileImage ? (
              <CdnImage
                className="block object-contain lg:absolute lg:hidden"
                url={builderMobileImage}
                alt={imageAltText}
                steps={[480]}
                style={{
                  width: '100%',
                  height: '100%',
                  maxHeight: '18rem'
                }}
              />
            ) : (
              <CloudinaryImage
                className="block object-contain lg:absolute lg:hidden"
                publicId={cloudinaryMobileImage?.public_id}
                alt={imageAltText}
                steps={[480]}
                style={{
                  width: '100%',
                  height: '100%',
                  maxHeight: '18rem'
                }}
              />
            )} */}
          </div>
        </div>
      </>
    )
  }

  return (
    <>
      <div
        // hidden sm:block
        className="relative  flex flex-col bg-white bg-auto bg-no-repeat lg:bg-100%"
        style={{ backgroundImage: `url(${backgroundImage ?? ''})` }}
      >
        {getContent()}
        {showButton && (
          <div className="order-3 block lg:hidden">
            <CTAFive {...CTAButton} backgroundColor="transparent" buttonAlignment="center" />
          </div>
        )}
      </div>
      {/* <div className="relative bg-white bg-no-repeat block sm:hidden" style={{ backgroundImage: `url(${mobileBackgroundImage})` }}>
        {getContent()}
      </div> */}
    </>
  )
}

export default TextImage

Builder.registerComponent(TextImage, {
  name: 'TextImage',
  inputs: [
    {
      name: 'backgroundImage',
      type: 'file',
      defaultValue: null
    },
    // {
    //   name: 'mobileBackgroundImage',
    //   type: 'file',
    //   defaultValue: null
    // },
    {
      name: 'imageSide',
      type: 'string',
      enum: ['left', 'right'],
      defaultValue: 'left'
    },
    // {
    //   name: 'cloudinaryImage',
    //   type: 'cloudinaryImageEditor'
    // },
    // {
    //   name: 'cloudinaryMobileImage',
    //   type: 'cloudinaryImageEditor'
    // },
    {
      name: 'builderImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'builderMobileImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },

    {
      name: 'imageAltText',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'enableTopic',
      type: 'boolean',
      defaultValue: true
    },
    {
      name: 'topicText',
      type: 'text',
      defaultValue: 'INTRODUCING'
    },
    {
      name: 'topicTextColor',
      type: 'color',
      defaultValue: 'purple'
    },
    {
      ...headingTypePropObj
    },
    {
      ...headingClassPropObj
    },
    {
      name: 'headingText',
      type: 'text',
      defaultValue: 'Javascript for Beginners'
    },
    {
      name: 'headingTextColor',
      type: 'color',
      defaultValue: 'black'
    },
    {
      name: 'contentText',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'textAlignment',
      type: 'string',
      enum: ['left', 'center', 'right'],
      defaultValue: 'left'
    },
    {
      name: 'bulletPoint',
      type: 'file',
      defaultValue: Bullet
    },
    {
      name: 'bulletAltText',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'points',
      type: 'list',
      subFields: [{ name: 'text', type: 'string' }],
      defaultValue: []
    },
    {
      name: 'contextFooter',
      type: 'string',
      defaultValue: ''
    },
    {
      ...CTAFiveRegisterProps,
      name: 'CTAButton'
    },
    {
      name: 'showButton',
      type: 'boolean',
      defaultValue: true
    }
  ]
})
